export default {"src":"/_next/static/media/development.45c459f8.svg","height":124,"width":125,"blurWidth":0,"blurHeight":0};